import type {
	CreateShareLinkInput,
	CreateShareLinkResponse,
	RecordShareEventInput,
	ResolveShareLinkResponse,
	ShareHistoryResponse,
} from "@shared/types";
import { apiClient } from "@/lib/api-client";

const API_BASE = "/api/v1";

export async function createShareLink(
	input: CreateShareLinkInput,
): Promise<CreateShareLinkResponse> {
	const response = await apiClient.post(`${API_BASE}/share-links`, input);
	return response.data.data;
}

export async function resolveShareLink(
	token: string,
): Promise<ResolveShareLinkResponse> {
	const response = await apiClient.get(`${API_BASE}/share/${token}`);
	return response.data.data;
}

export async function recordShareEvent(
	token: string,
	input: RecordShareEventInput,
): Promise<void> {
	await apiClient.post(`${API_BASE}/share/${token}/events`, input);
}

export async function revokeShareLink(shareLinkId: string): Promise<void> {
	await apiClient.post(`${API_BASE}/share-links/${shareLinkId}/revoke`);
}

export async function getProjectShareLinks(
	projectId: string,
	options?: { signal?: AbortSignal },
): Promise<ShareHistoryResponse> {
	const response = await apiClient.get(
		`${API_BASE}/projects/${projectId}/share-links`,
		{ signal: options?.signal },
	);
	return response.data.data;
}
